import { render, staticRenderFns } from "./EditMedicalAdvice.vue?vue&type=template&id=5114ecd6&scoped=true"
import script from "./EditMedicalAdvice.vue?vue&type=script&lang=js"
export * from "./EditMedicalAdvice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5114ecd6",
  null
  
)

export default component.exports